import Vue from "vue";
import { mapGetters } from "vuex";

import { ErrorLogService, EventTrackingService, PartDetailServices } from "@/services";

import { LoadingSpinner, StaticFormControl } from "@/components";
import { inputValidateState } from "@/components/mixins/inputValidateState";

import { default as SendError } from "../SendError.vue";
import { default as ThankYou } from "../ThankYou.vue";

export default Vue.extend({
    name: "BreakCrossReference",
    mixins: [inputValidateState],
    components: {
        ThankYou,
        LoadingSpinner,
        SendError,
        StaticFormControl,
    },
    computed: {
        ...mapGetters(["user", "getContentItem", "activeAccountId", "SiteName"]),
        formIsValid(){
            return this.breakOem && this.breakPartNumber && this.sourceOfInformation;
        }
    },
    props: {
        details: {
            type: Object,
            default: () => {},
        },
    },
    data: () => ({
        showThankYou: false,
        showSendError: false,
        submittingForm: false,
        errorMessage: "",
        haveVisitedBreakOemInput: false,
        haveVisitedBreakPartNumberInput: false,
        haveVisitedSourceOfInformationInput: false,

        // form fields
        breakOem: "",
        breakPartNumber: "",
        sourceOfInformation: "",
        comment: "",
    }),
    methods: {
        async submitForm() {
            try {
                this.showThankYou = false;
                this.submittingForm = true;

                var headerParams = {
                    oemPartCode: this.details.OemPartCode,
                    siteName: this.SiteName,
                    partDescription: this.details.PartDescription,
                    breakOem: this.breakOem,
                    breakPartNumber: this.breakPartNumber,
                    breakSource: this.sourceOfInformation,
                    breakComments: this.comment
                }

                await PartDetailServices.sendCrossBreakEmail(headerParams, this.user);

                EventTrackingService.trackEvent({
                  category: "Part Detail",
                  action: "Suggest Break Cross",
                  label: `${this.breakOem}-${this.crossPartNumber}`,
                  value: 1,
                });

                this.showThankYou = true;
            } catch (err) {
                this.showSendError = true;
                this.errorMessage = ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.submittingForm = false;

            }
        },
        hideForm(){
            this.$emit("hide");
        },
        checkRequiredField(field: any, inputHasBeenVisited: boolean){
            if(!inputHasBeenVisited){
                return null;
            }
            if(field){
                return true;
            }
            return false;
        },
        resetForm(){
            this.showThankYou = false;
            this.showSendError = false;
        }
    },
});
